const typography = {
  fontFamily: '"Inter", sans-serif',
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,
  fontSize: 16,

  allVariants: {
    get fontFamily() {
      return typography.fontFamily;
    },
  },

  h1: {
    get fontFamily() {
      return typography.fontFamily;
    },
    get fontWeight() {
      return typography.fontWeightBold;
    },
    fontSize: '2.25rem',
    lineHeight: '2.5rem',
  },

  h2: {
    get fontFamily() {
      return typography.fontFamily;
    },
    get fontWeight() {
      return typography.fontWeightBold;
    },
    fontSize: '2rem',
    lineHeight: '2.375rem',
  },

  h3: {
    get fontFamily() {
      return typography.fontFamily;
    },
    get fontWeight() {
      return typography.fontWeightBold;
    },
    fontSize: '1.5rem',
    lineHeight: '1.75rem',
  },

  h4: {
    get fontFamily() {
      return typography.fontFamily;
    },
    get fontWeight() {
      return typography.fontWeightBold;
    },
    fontSize: '1.25rem',
    lineHeight: '1.5rem',
  },

  h5: {
    get fontFamily() {
      return typography.fontFamily;
    },
    get fontWeight() {
      return typography.fontWeightBold;
    },
    fontSize: '1.125rem',
    lineHeight: '1.25rem',
  },

  h6: {
    get fontFamily() {
      return typography.fontFamily;
    },
    get fontWeight() {
      return typography.fontWeightSemiBold;
    },
    fontSize: '1rem',
    lineHeight: '1.25rem',
  },

  body1: {
    get fontFamily() {
      return typography.fontFamily;
    },
    get fontWeight() {
      return typography.fontWeightMedium;
    },
    fontSize: '1rem',
    lineHeight: '1.25rem',
  },

  body2: {
    get fontFamily() {
      return typography.fontFamily;
    },
    get fontWeight() {
      return typography.fontWeightRegular;
    },
    fontSize: '1rem',
    lineHeight: '1.25rem',
  },

  // custom body
  body3: {
    get fontFamily() {
      return typography.fontFamily;
    },
    get fontWeight() {
      return typography.fontWeightMedium;
    },
    fontSize: '0.875rem',
    lineHeight: '1.125rem',
  },

  // custom body
  body4: {
    get fontFamily() {
      return typography.fontFamily;
    },
    get fontWeight() {
      return typography.fontWeightRegular;
    },
    fontSize: '0.875rem',
    lineHeight: '1.125rem',
  },

  button: {
    get fontFamily() {
      return typography.fontFamily;
    },
    get fontWeight() {
      return typography.fontWeightBold;
    },
    fontSize: '1rem',
    lineHeight: '1.25rem',
    textDecoration: 'none',
  },

  // custom button
  button2: {
    get fontFamily() {
      return typography.fontFamily;
    },
    get fontWeight() {
      return typography.fontWeightSemiBold;
    },
    fontSize: '0.875rem',
    lineHeight: '1.125rem',
    textDecoration: 'none',
  },

  caption: {
    get fontFamily() {
      return typography.fontFamily;
    },
    get fontWeight() {
      return typography.fontWeightSemiBold;
    },
    fontSize: '0.75rem',
    lineHeight: '1rem',
  },

  // custom caption
  caption2: {
    get fontFamily() {
      return typography.fontFamily;
    },
    get fontWeight() {
      return typography.fontWeightRegular;
    },
    fontSize: '0.75rem',
    lineHeight: '1rem',
  },

  subtitle1: {
    get fontFamily() {
      return typography.fontFamily;
    },
  },

  subtitle2: {
    get fontFamily() {
      return typography.fontFamily;
    },
  },

  overline: {
    get fontFamily() {
      return typography.fontFamily;
    },
  },
};

export default typography;
